import React, { FC } from 'react';
import { FormCheck } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';

export interface Props {
  value: Array<string>;
  options:
    | { text: JSX.Element | string; description?: string; value: string; disabled?: boolean; errorMessage?: string }[]
    | undefined;
  onChange: (value: string[]) => void;
  multiSelection: boolean | undefined;
  readOnlyMode?: boolean;
  className?: string;
}

const OptionList: FC<Props> = ({ value, options, onChange, multiSelection, readOnlyMode, className }: Props) => {
  if (!options || options.length === 0) {
    return null;
  }

  const selectOption = (optionValue: string) => {
    if (multiSelection) {
      if (value && value.includes(optionValue)) {
        const newValue = value.filter((val) => val !== optionValue);
        onChange(newValue);
      } else {
        onChange((value || []).concat(optionValue));
      }
    } else {
      if (value && optionValue === value[0]) {
        onChange([]);
      } else {
        onChange([optionValue]);
      }
    }
  };

  return (
    <div className="option-list">
      {options.map((option) => {
        const label = (
          <div className="w-100 option-container" onClick={(e) => e.stopPropagation()}>
            <div>{option.text}</div>
            {option.description && <div className="option-description">{option.description}</div>}
          </div>
        );

        return (
          <div
            className="option"
            key={option.value}
            onClick={(e) => {
              e.stopPropagation();
              if (!readOnlyMode && !option.disabled) {
                selectOption(option.value);
              }
              return false;
            }}
          >
            {multiSelection && (
              <>
                <FormCheck
                  key={option.value}
                  type="checkbox"
                  id={`check-${option.value}-${uuidv4()}`}
                  checked={value && value.includes(option.value)}
                  label={label}
                  disabled={readOnlyMode || option.disabled}
                  readOnly={readOnlyMode}
                  className={className}
                />
              </>
            )}
            {!multiSelection && (
              <>
                <FormCheck
                  id={`radio-${option.value}-${uuidv4()}`}
                  checked={value && option.value === value[0]}
                  type="radio"
                  key={option.value}
                  label={label}
                  disabled={readOnlyMode || option.disabled}
                  readOnly={readOnlyMode}
                  className={className}
                />
              </>
            )}

            {option.errorMessage && (
              <div className="feedback-container mt-2">
                <div className="feedback-invalid" data-testid="feedback-invalid">
                  {option.errorMessage}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OptionList;
